import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CarIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.99017 3.16982C4.44409 3.07619 3.9259 3.44448 3.83484 3.99103L3 8.00006H1.5C1.25903 7.96562 1.04346 8.15262 1.04346 8.39603L1 11.6001C1 11.821 1.17908 12.0001 1.40002 12.0001H2.05C2.16046 12.0001 2.2488 11.9101 2.26127 11.8004C2.36036 10.9279 3.10103 10.2501 4 10.2501C4.89897 10.2501 5.63964 10.9279 5.73873 11.8004C5.7512 11.9101 5.83954 12.0001 5.95 12.0001H10.25C10.25 11.0336 11.0335 10.2501 12 10.2501C12.899 10.2501 13.6396 10.9279 13.7387 11.8004C13.7512 11.9101 13.8395 12.0001 13.95 12.0001H14.6C14.8209 12.0001 15 11.821 15 11.6001V9.34699C15 9.14792 14.8536 8.97916 14.6566 8.95101L12 8.00006L11.1389 4.86669C11.0551 4.46446 10.7338 4.15444 10.3289 4.08501L4.99017 3.16982ZM6.43774 4.28763C6.59033 4.31815 6.94762 4.54636 6.93047 4.70102L6.5 7.50006C6.48096 7.67111 6.5 8.00006 6.03656 8.00006H4.54072C4.41558 8.00006 4.32118 7.88643 4.34411 7.76341L4.85052 5.04656C4.9317 4.47824 5.47363 4.0948 6.03656 4.2074L6.43774 4.28763ZM8.14771 8.00006C7.99054 7.97386 7.98242 7.65842 8 7.50006L8.14771 4.96207C8.16718 4.7872 8.33221 4.66652 8.5047 4.70102L9.30621 4.86133C9.72198 4.94448 10.0401 5.28076 10.1 5.70049L10.307 7.78026C10.3187 7.89796 10.2263 8.00006 10.108 8.00006H8.14771Z"
		/>
		<path
			fill="currentColor"
			d="M13 12.0001C13 11.4478 12.5523 11.0001 12 11.0001C11.4477 11.0001 11 11.4478 11 12.0001C11 12.5524 11.4477 13.0001 12 13.0001C12.5523 13.0001 13 12.5524 13 12.0001Z"
		/>
		<path
			fill="currentColor"
			d="M4 11.0001C4.55231 11.0001 5 11.4478 5 12.0001C5 12.5524 4.55231 13.0001 4 13.0001C3.44769 13.0001 3 12.5524 3 12.0001C3 11.4478 3.44769 11.0001 4 11.0001Z"
		/>
	</svg>
))
